import { Button, Form, Input, InputNumber, Table } from "antd";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { applyDiscount, getFranchiseDiscount } from "../../redux/rtk/features/discount/discountSlice";
import CrmSearch from "../CRM/CommonUi/CrmSearch";
import { toast } from "react-toastify";

function ApplyDiscount({ userId, setIsFormChanged }) {
    const { id } = useParams();
    const [form] = Form.useForm();
    const { isApplyingDiscount, isFetchingFranchiseDiscount } = useSelector(state => state.discount)
    const [discountData, setDiscountData] = useState([])
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const getDiscountData = async () => {
        const discountData = await dispatch(getFranchiseDiscount(userId || id)).unwrap();
        setDiscountData(discountData?.data)
    }
    useEffect(() => {
        getDiscountData();
    }, [])



    const onFinish = async (callback) => {
        try {
            form.validateFields();
            const formattedData = discountData.map(({ id, playerCount, weekDiscount, weekendDiscount }) => ({
                playerCount: playerCount,
                weekDiscount: Number(weekDiscount),
                weekendDiscount: Number(weekendDiscount),
                userId: parseInt(userId)
            }));
            await dispatch(applyDiscount(formattedData)).unwrap();
            setIsFormChanged({
                submitFunction: null,
                state: false
            })
            callback()
        } catch (error) {
            console.error('Form submission error:', error);
            // Check if error is a validation error
            if (error?.errorFields) {
                toast.error("Please fill all the required fields");
                throw new Error("Please fill all the required fields");
            }
        }
    };

    // Handle input changes
    const handleInputChange = (key, field, value) => {
        setIsFormChanged({
            submitFunction: onFinish,
            state: true
        })
        setDiscountData((prevData) =>
            prevData.map((item) =>
                item.id === key ? { ...item, [field]: value } : item
            )
        );
    };

    const columns = [
        {
            id: 1,
            title: "Players Number",
            dataIndex: "playerCount",
            key: "playerNumber",
        },
        {
            id: 2,
            title: "Per Person Week Discount (₹)",
            dataIndex: "weekDiscount",
            key: "weekDiscount",
            render: (text, record) => (
                <div className='w-full h-full flex items-center justify-center'>
                    <Form.Item
                        style={{ marginBottom: 0, width: "100%" }}
                        className="form-item-alignment w-full m-0"
                        name={`weekDiscount-${record?.id}`}
                        initialValue={record?.weekDiscount}
                        rules={[
                            {
                                required: true,
                                message: "Please input Discount Amount!",
                            },
                            {
                                type: 'number',
                                transform: (value) => Number(value),
                                validator: (_, value) => {
                                    if (Number.isInteger(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('Please enter a whole number!');
                                }
                            }
                        ]}
                    >
                        <InputNumber
                            controls={false}
                            className="w-full p-1 "
                            placeholder="Per Person Discount Amount"
                            onChange={(val) => handleInputChange(record?.id, "weekDiscount", val)}

                        />
                    </Form.Item>
                </div>
            ),
        },
        {
            id: 3,
            title: "Per Person Weekend Discount (₹)",
            dataIndex: "weekendDiscount",
            key: "weekendDiscount",
            render: (text, record) => (
                <div className='w-full h-full flex items-center justify-center'>
                    <Form.Item
                        style={{ marginBottom: 0, width: "100%" }}
                        name={`weekendDiscount-${record?.id}`}
                        initialValue={record?.weekendDiscount}
                        className="form-item-alignment w-full m-0"
                        rules={[
                            {
                                required: true,
                                message: "Please input Discount Amount!",
                            },
                            {
                                type: 'number',
                                transform: (value) => Number(value),
                                validator: (_, value) => {
                                    if (Number.isInteger(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('Please enter a whole number!');
                                }
                            }
                        ]}
                    >
                        <InputNumber
                            controls={false}
                            className="w-full"
                            placeholder="Per Person Discount Amount"
                            value={record?.weekendDiscount}
                            onChange={(val) => handleInputChange(record?.id, "weekendDiscount", val)}

                        />
                    </Form.Item>
                </div>
            ),
        }
    ];
    return (
        <div className='mr-top mb-4 px-6 pb-6 pt-4 ant-card franchise-last-step border-radius-bottom' style={{ maxWidth: "100%" }}>

            <Form
                form={form}
                layout="vertical"
            >

                <div className="mt-3 mb-5 flex items-center justify-between">
                    <h2 style={{ fontSize: "1.5rem" }} className=" flex justify-start text-xl text-danger hover:text-dangerHover font-semibold">
                        <span className="pb-1 border-b-2 border-danger inline-block md:w-max">Apply Discount</span>
                    </h2>
                    <div className="hidden md:flex text-end">
                        <CrmSearch />
                    </div>
                </div>
                <Table
                    scroll={{ x: true }}
                    loading={isFetchingFranchiseDiscount}
                    pagination={false}
                    columns={columns}
                    dataSource={discountData ? discountData?.map((item) => ({ ...item, key: item.id })).sort((a, b) => a.playerCount - b.playerCount) : []}
                    rowKey={record => record.id}
                    className="players-table"
                    rowClassName={(record, index) =>
                        index % 2 === 0 ? "even-row" : "odd-row"
                      }
                />
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <Form.Item
                        style={{ marginBottom: "10px", marginTop: "10px" }}
                        wrapperCol={{ span: 24 }}
                        className="flex justify-end"
                    >
                        <Button
                            className='mt-5 btn-primary border-none w-max'
                            size='large'
                            block
                            htmlType='button'
                            onClick={() => onFinish(() => navigate("/admin/franchises"))}
                            shape='round'
                            loading={isApplyingDiscount}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </div>
    )
}

export default ApplyDiscount